// Fonte: Drive "3. Tech & Product/IA Repository/01_strategy_company_wide/marketing_assets/INDEX.md"
// (fonte canônica da marca Conducco — brand book + foundations).
export const CONDUCCO_PRIMARY = "#3024E1";
export const CONDUCCO_DARK = "#0F0F1E";
export const CONDUCCO_ACCENT = "#31F7FF";
export const INSIGHTS_BORDER = "#E0E0E0";
export const INSIGHTS_FONT = "Sora, sans-serif";
